Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    fontBold = _STYLES$useStyles.fontBold,
    fontRegular = _STYLES$useStyles.fontRegular,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight;
  var styles = _reactNative.StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'center'
    },
    number: Object.assign({}, fontBold, {
      fontSize: fontSize.l,
      lineHeight: lineHeight.l,
      color: COLORS.aubergine,
      textAlign: 'center'
    }),
    unit: Object.assign({}, fontRegular, {
      fontSize: fontSize.s,
      lineHeight: lineHeight.s,
      color: COLORS.aubergine
    }),
    innerContent: {
      position: 'absolute'
    },
    textContainer: {
      marginBottom: 0,
      textAlign: 'center'
    }
  });
  return {
    styles: styles
  };
};